import { RouteInfo } from "./vertical-menu.metadata";
import {
  COURSE_SESSIONS_PATH,
  EMERGENCY_HELP_PATH,
  HOME_PATH,
  MY_JOURNALS_PATH,
} from "@sdk/lib/values/shared-paths";

export const ROUTES: RouteInfo[] = [
  {
    path: `/${HOME_PATH}`,
    title: "Dashboard",
    icon: "ft-command",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: `/${COURSE_SESSIONS_PATH}`,
    title: "Course session",
    icon: "fa fa-users",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: `/${MY_JOURNALS_PATH}`,
    title: "My journey",
    icon: "ft-book-open",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: `/${EMERGENCY_HELP_PATH}`,
    title: "Emergency help kit",
    icon: "fa fa-medkit",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
];
